import React from "react";
import { Tag } from "antd";
import { PALETTES } from "./ButtonItem";

const hex6 = (color) => (/^#[0-9a-fA-F]{8}$/.test(color) ? color.slice(0, 7) : color);

export const colorPaleta = (nombre) => hex6((PALETTES[nombre] || PALETTES.gris).base);

const TagItem = ({ children, solido, icon, style, className, onClick, ...props }) => {
  const nombre = Object.keys(PALETTES).find((k) => props[k]) || "gris";
  const paleta = PALETTES[nombre];
  const base = hex6(paleta.base);
  const esHex = /^#[0-9a-fA-F]{6}$/.test(base);
  const estilo = solido
    ? { backgroundColor: base, borderColor: base, color: paleta.text }
    : { backgroundColor: esHex ? `${base}1A` : "#f5f5f5", borderColor: esHex ? `${base}66` : base, color: base };
  return (
    <Tag
      icon={icon}
      className={className}
      onClick={onClick}
      style={{ borderRadius: 999, padding: "0 10px", fontWeight: 500, ...estilo, ...style }}
    >
      {children}
    </Tag>
  );
};

export default TagItem;
